import { useLocation } from "react-router-dom";
import { getCurrentTaxFilingYear } from "./getCurrentTaxFilingYear";
import { TaxYear } from "../../../shared/constants/taxYear";

export const useCurrentTaxFilingYear = (): TaxYear => {
  const { pathname } = useLocation();

  return getCurrentTaxFilingYear(pathname);
};
